import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import colors from "assets/theme/base/colors";
import "react-toastify/dist/ReactToastify.css";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const Faculty = () => {
  // State variables
  const [faculties, setFaculties] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [showAddFacultyModal, setShowAddFacultyModal] = useState(false);
  const [showUpdateFacultyModal, setShowUpdateFacultyModal] = useState(false);
  const [showDeleteFacultyModal, setShowDeleteFacultyModal] = useState(false);
  const [currentFacultyId, setCurrentFacultyId] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [formErrors, setFormErrors] = useState({ name: "", description: "" });
  const [showViewFacultyModal, setShowViewFacultyModal] = useState(false);
  const [selectedFaculty, setSelectedFaculty] = useState(null);

  // Dummy data for faculties
  const dummyData = [
    { id: 1, name: "Faculty A", description: "Description for Faculty A" },
    { id: 2, name: "Faculty B", description: "Description for Faculty B" },
    { id: 3, name: "Faculty C", description: "Description for Faculty C" },
    { id: 4, name: "Faculty D", description: "Description for Faculty D" },
    { id: 5, name: "Faculty E", description: "Description for Faculty E" },
  ];

  // Fetch faculties
  const getFaculties = async () => {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    await fetch(`${BASE_URL}/faculty/get_faculties`, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        setFaculties(data.faculties);
      })
      .catch((error) => console.log(error));
    // setFaculties(dummyData);
  };

  // Add faculty
  const addFaculty = () => {
    let data = { name, description };
    const newFaculty = { id: faculties.length + 1, ...data };
    setFaculties([...faculties, newFaculty]);
    toast.success("Faculty added successfully");
    setName("");
    setDescription("");
    setShowAddFacultyModal(false);
  };

  // Delete faculty
  const deleteFaculty = () => {
    const updatedFaculties = faculties.filter(
      (faculty) => faculty.id !== currentFacultyId
    );
    setFaculties(updatedFaculties);
    toast.success("Faculty deleted successfully");
    setShowDeleteFacultyModal(false);
  };

  // Update faculty
  const updateFaculty = () => {
    const updatedFaculties = faculties.map((faculty) => {
      if (faculty.id === currentFacultyId) {
        return { ...faculty, name, description };
      }
      return faculty;
    });
    setFaculties(updatedFaculties);
    toast.success("Faculty updated successfully");
    setShowUpdateFacultyModal(false);
  };

  // Search functionality
  const handleSearchKeywordChange = (e) => {
    const searchTerm = e.target.value.trim().toLowerCase();
    setSearchKeyword(searchTerm);

    if (searchTerm === "") {
      getFaculties();
    } else {
      const filteredFaculties = faculties.filter((faculty) => {
        const nameMatch = faculty.name.toLowerCase().includes(searchTerm);
        const emailMatch = faculty.email.toLowerCase().includes(searchTerm);
        const campusMatch = faculty.campus_name
          .toLowerCase()
          .includes(searchTerm);
        return nameMatch || emailMatch || campusMatch;
      });
      setFaculties(filteredFaculties);
    }
  };

  // Dialog handlers
  const showFacultyAddModal = () => setShowAddFacultyModal(true);
  const showFacultyUpdateModal = (id) => {
    setCurrentFacultyId(id);
    const faculty = faculties.find((f) => f.id === id);
    setName(faculty.name);
    setDescription(faculty.description);
    setShowUpdateFacultyModal(true);
  };

  const showFacultyDeleteModal = (id) => {
    setCurrentFacultyId(id);
    setShowDeleteFacultyModal(true);
  };

  const viewFaculty = (id) => {
    const faculty = faculties.find((f) => f.id === id);
    setSelectedFaculty(faculty);
    setShowViewFacultyModal(true);
  };

  // Initial render
  useEffect(() => {
    getFaculties();
  }, []);

  const columns = [
    { Header: "Sr.No", accessor: "serial", align: "center" },
    { Header: "Faculty Name", accessor: "faculty_name", align: "center" },
    { Header: "Email", accessor: "email", align: "center" },
    { Header: "Campus", accessor: "campus", align: "center" },
    // { Header: "Actions", accessor: "actions", align: "center" },
  ];

  const rows = faculties.map((faculty, index) => ({
    serial: index + 1,
    faculty_name: faculty.name,
    email: faculty.email,
    campus: faculty.campus_name,
    // actions: (
    //   <>
    //     <IconButton onClick={() => showFacultyUpdateModal(faculty.id)}>
    //       <EditIcon style={{ color: "#66CDAA" }} />
    //     </IconButton>
    //     <IconButton onClick={() => viewFaculty(faculty.id)}>
    //       <VisibilityOutlinedIcon style={{ color: "#45B3FA" }} />
    //     </IconButton>
    //     <IconButton onClick={() => showFacultyDeleteModal(faculty.id)}>
    //       <DeleteIcon style={{ color: "#FF6F30" }} />
    //     </IconButton>
    //   </>
    // ),
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card className="card1">
              <MDBox
                mx={0}
                mt={0}
                py={2}
                px={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Paper component="form" className="search-paper">
                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search"
                    inputProps={{ "aria-label": "search faculty" }}
                    value={searchKeyword}
                    onChange={handleSearchKeywordChange}
                  />
                  <SearchIcon className="search-icon" />
                </Paper>
                {/* <Button
                  variant="filled"
                  endIcon={
                    <AddIcon
                     className="add-icon"
                    />
                  }
                  onClick={showFacultyAddModal}
                  className="add-button"
                >
                  Add
                </Button> */}
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Add Faculty Dialog */}
      <Dialog
        open={showAddFacultyModal}
        onClose={() => setShowAddFacultyModal(false)}
        PaperProps={{
          sx: {
            width: "627px",
            height: "722px",
            borderRadius: "20px",
            opacity: 1,
          },
        }}
      >
        <DialogTitle>Add Faculty</DialogTitle>
        <DialogContent>
          <InputBase
            placeholder="Faculty Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: "100%", marginBottom: "10px" }}
          />
          <div style={{ color: "red" }}>{formErrors.name}</div>
          <InputBase
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{ width: "100%" }}
          />
          <div style={{ color: "red" }}>{formErrors.description}</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAddFacultyModal(false)}>Cancel</Button>
          <Button onClick={addFaculty}>Add</Button>
        </DialogActions>
      </Dialog>

      {/* Update Faculty Dialog */}
      <Dialog
        open={showUpdateFacultyModal}
        onClose={() => setShowUpdateFacultyModal(false)}
      >
        <DialogTitle>Update Faculty</DialogTitle>
        <DialogContent>
          <InputBase
            placeholder="Faculty Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ width: "100%", marginBottom: "10px" }}
          />
          <div style={{ color: "red" }}>{formErrors.name}</div>
          <InputBase
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{ width: "100%" }}
          />
          <div style={{ color: "red" }}>{formErrors.description}</div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowUpdateFacultyModal(false)}
            sx={{ border: "1px solid #FA896B" }}
          >
            Cancel
          </Button>
          <Button onClick={updateFaculty}>Update</Button>
        </DialogActions>
      </Dialog>

      {/* Delete Faculty Dialog */}
      <Dialog
        open={showDeleteFacultyModal}
        onClose={() => setShowDeleteFacultyModal(false)}
      >
        <DialogTitle>Delete Faculty</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this faculty?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDeleteFacultyModal(false)}>
            Cancel
          </Button>
          <Button onClick={deleteFaculty}>Delete</Button>
        </DialogActions>
      </Dialog>

      {/* View Faculty Dialog */}
      <Dialog
        open={showViewFacultyModal}
        onClose={() => setShowViewFacultyModal(false)}
      >
        <DialogTitle>View Faculty</DialogTitle>
        <DialogContent>
          {selectedFaculty && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                }}
              >
                <strong style={{ width: "100px" }}>Name</strong>
                <span style={{ color: "gray", marginLeft: "76px" }}>
                  {selectedFaculty.name}
                </span>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <strong style={{ width: "100px" }}>Description</strong>
                <span style={{ color: "gray", marginLeft: "76px" }}>
                  {selectedFaculty.description}
                </span>
              </div>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowViewFacultyModal(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default Faculty;
